import { normalizeDesign, normalizeCart, normalizeProductCatalog, PRODUCTS } from './design-model.js';
const DATABASE = 'nail-atelier-studio-v2';
let dbPromise;
function openDatabase() {
  if (!dbPromise) dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore('records');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  return dbPromise;
}
export async function readRecord(key) {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('records', 'readonly');
    const req = tx.objectStore('records').get(key);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
export async function writeRecord(key, value) {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('records', 'readwrite');
    tx.objectStore('records').put(value, key);
    tx.oncomplete = () => resolve(value);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error || new Error('存储已取消'));
  });
}
function legacy(key) { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } }
function mergedProductCatalog(cached,live){
  return normalizeProductCatalog([...PRODUCTS,...normalizeProductCatalog(cached),...normalizeProductCatalog(live)]);
}
export async function restoreStudio(liveProducts=null) {
  const [draft, cart, works, cachedProducts] = await Promise.all([readRecord('draft'), readRecord('cart'), readRecord('works'), readRecord('product-catalog')]);
  const products=mergedProductCatalog(cachedProducts,liveProducts);
  const source = draft || legacy('nail-atelier:design:v1');
  return { hasDraft: Boolean(source), design: normalizeDesign(source), cart: normalizeCart(cart || legacy('nail-atelier:cart:v1') || [],products), works: Array.isArray(works) ? works : [], products };
}
export async function saveProductCatalog(liveProducts) {
  const live=normalizeProductCatalog(liveProducts),db=await openDatabase();
  // Read and merge in one write transaction so concurrent tabs cannot erase each other's past SKUs.
  return new Promise((resolve,reject)=>{
    const tx=db.transaction('records','readwrite'),records=tx.objectStore('records'),request=records.get('product-catalog');
    let products;
    request.onsuccess=()=>{products=mergedProductCatalog(request.result,live);records.put(products,'product-catalog');};
    tx.oncomplete=()=>resolve(products);
    tx.onerror=()=>reject(tx.error);
    tx.onabort=()=>reject(tx.error||new Error('商品目录保存已取消'));
  });
}
export async function saveDraft(design) { return writeRecord('draft', normalizeDesign(design)); }
export async function saveCart(cart,products=PRODUCTS) { return writeRecord('cart', normalizeCart(cart,products)); }
export async function saveWorks(works) { return writeRecord('works', works); }
export async function requestDesignCode(design) {
  const response = await fetch('/nail-api/designs', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({design:normalizeDesign(design)}) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || '设计分享服务暂时不可用，请先导出设计文件');
  return result;
}
export async function retrieveDesignCode(input) {
  let code = input.trim().toUpperCase();
  if (/^https?:/i.test(input)) { try { code = new URL(input).searchParams.get('design')?.toUpperCase() || ''; } catch { code = ''; } }
  if (!/^AT-[A-F0-9]{20}$/.test(code)) throw new Error('请输入本站生成的 AT- 开头设计码或分享链接');
  const response = await fetch(`/nail-api/designs/${encodeURIComponent(code)}`);
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || '设计码读取失败');
  return normalizeDesign(result.design);
}

export async function deleteRecord(key) {
  const db = await openDatabase();
  return new Promise((resolve,reject)=>{
    const tx=db.transaction('records','readwrite');tx.objectStore('records').delete(key);
    tx.oncomplete=()=>resolve();tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error||new Error('存储已取消'));
  });
}
